import { authFetch, API_BASE_URL, getHeaders } from './authFetch';

export interface SubmitContactParams {
  email: string;
  inquiryType: string;
  content: string;
  file?: File | null;
}

export interface SubmitSalesContactParams {
  name: string;
  email: string;
  company?: string;
  message?: string;
}

export async function submitContactInquiry(params: SubmitContactParams): Promise<{ ok: boolean }> {
  const formData = new FormData();
  formData.append('email', params.email);
  formData.append('inquiry_type', params.inquiryType);
  formData.append('content', params.content);
  if (params.file) {
    formData.append('attachment', params.file);
  }

  const headers = getHeaders(false);

  const res = await authFetch(`${API_BASE_URL}/api/v1/contact/submit`, {
    method: 'POST',
    headers,
    body: formData,
  });

  if (!res.ok) {
    const body = await res.json().catch(() => null);
    throw new Error(body?.detail || `Request failed (${res.status})`);
  }

  return res.json();
}

export async function submitSalesContactInquiry(
  params: SubmitSalesContactParams,
): Promise<{ ok: boolean }> {
  const formData = new FormData();
  formData.append('name', params.name);
  formData.append('email', params.email);
  formData.append('company', params.company ?? '');
  formData.append('message', params.message ?? '');

  const res = await fetch(`${API_BASE_URL}/api/v1/contact/sales`, {
    method: 'POST',
    headers: getHeaders(false),
    body: formData,
    credentials: 'include',
  });

  if (!res.ok) {
    const body = await res.json().catch(() => null);
    throw new Error(body?.detail || `Request failed (${res.status})`);
  }

  return res.json();
}
